import { takeLatest, put, call, select } from 'redux-saga/effects';
import ChangelogActions, { ChangelogTypes } from '../Redux/ChangelogRedux';
import { OtTypes } from '../Redux/OtRedux';
import ApiResponseError from '../Services/ApiResponseError';

export function * getChangelog(api, { entity_name, resource_id, query, callback }) {
    try {
        const response = yield call(api.getChangelogCollection, entity_name, resource_id, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(ChangelogActions.fetchChangelogSuccess(response.data.data.logs));
    } catch (e) {
        yield put(ChangelogActions.fetchChangelogFailure(e));
    }
}
export function * getOtChangelogFromState(api) {
    try {
        const ot = yield select((state) => state.ot.otToEdit );
        if (!ot){
            throw Error('Ot not defined in store');
        }
        const response = yield call(api.getChangelogCollection, 'ot', ot.uuid, {inflators: 'modifier'});
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(ChangelogActions.fetchChangelogSuccess(response.data.data.logs));
    } catch (e) {
        yield put(ChangelogActions.fetchChangelogFailure(e));
    }
}

export function * watchChangelog(api) {
    yield takeLatest(ChangelogTypes.FETCH_CHANGELOG, getChangelog, api);
    yield takeLatest(OtTypes.UPDATE_OT_SUCCESS, getOtChangelogFromState, api);

    yield takeLatest(OtTypes.CREATE_OT_DETAIL_SUCCESS, getOtChangelogFromState, api);
    yield takeLatest(OtTypes.DELETE_OT_DETAIL_SUCCESS, getOtChangelogFromState, api);

    yield takeLatest(OtTypes.CREATE_OT_TRANSACTION_SUCCESS, getOtChangelogFromState, api);
    yield takeLatest(OtTypes.DELETE_OT_TRANSACTION_SUCCESS, getOtChangelogFromState, api);

    yield takeLatest(OtTypes.CREATE_OT_ASSET_SUCCESS, getOtChangelogFromState, api);
    yield takeLatest(OtTypes.DELETE_OT_ASSET_SUCCESS, getOtChangelogFromState, api);
}



// WEBPACK FOOTER //
// ./src/Sagas/ChangelogSagas.js